<!--
 * @Author: cmchiu
 * @Date: 2022-09-02 17:53:21
 * @LastEditTime: 2023-01-12 09:22:15
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \LearningMarket2\LearningMarket-ClientApp\src\layout\index.vue
 * 
-->
<template>
    <div class="app-layout">
        <div class="app-main">
            <section class="section-right-shape padding-bottom padding-top">
                <div class="container">
                    <breadcrumb />

                    <div class="row">
                        <div class="col-lg-5 col-md-4 col-4" style="border-top: 1px solid #0e7767"></div>
                        <div class="col-lg-2 col-md-4 col-4">
                            <div class="section-header">
                                <span class="cate">學習市集</span>
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-4 col-4" style="border-top: 1px solid #0e7767"></div>
                    </div>

                    <!-- 開課需求調查 -->
                    <coursedemand />

                    <!-- 我的課程 -->
                    <mycourse />

                    <!-- 課程類別 -->
                    <courseclass />

                    <div class="row">
                        <router-view :key="key" />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Auth from '@/api/auth'
import { breadcrumb } from '@c/Breadcrumb'
import { coursedemand } from '@c/CourseDemand'
import { mycourse } from '@c/MyCourse'
import { courseclass } from '@c/CourseClass'

export default {
    name: 'AppLayout',

    components: { breadcrumb, coursedemand, mycourse, courseclass },

    data: function () {
        return {
            user: {
                isLogin: false,
                id: '',
                name: '',
                email: '',
                class: '',
            },
        }
    },

    computed: {
        key() {
            return this.$route.fullPath
        },
    },

    created: function () {
        /* this.$store.dispatch('user/checkLogin').then(() => {
            this.user = this.$store.getters.userInfo
            console.log(this)
            console.log('layout:', this.user)
        }) */
    },

    mounted: function () {
        const vm = this
        const timer = window.setInterval(() => {
            vm.$store.dispatch('user/checkLogin').then(isLogin => {
                // vm.user.isLogin = isLogin
                // if (isLogin) {
                vm.$store.dispatch('user/getUserInfo')
                // }
            })
        }, 1000)
        // 组件銷毀前, 清除定時器
        vm.$once('hook:beforeDestroy', () => {
            window.clearInterval(timer)
        })
    },

    methods: {
        // 檢查是否已登入(有合法cookie存在)
        async isLogin() {
            await Auth.isLogin().then(res => {
                this.user.isLogin = res
            })
        },

        // 從cookie提取user的id
        async getLogName() {
            return await Auth.getLogName()
        },

        async getAcpdById(id) {
            const vm = this
            await Auth.getAcpdById({ id }).then(res => {
                if (res.Code === 1) {
                    vm.user.id = res.Items.Id
                    vm.user.name = res.Items.Name
                    vm.user.email = res.Items.Email
                    vm.user.class = res.Items.Class
                }
            })
        },
    },
}
</script>
